import { render, staticRenderFns } from "./SchoolBanner.vue?vue&type=template&id=14b35df4&scoped=true"
import script from "./SchoolBanner.vue?vue&type=script&lang=js"
export * from "./SchoolBanner.vue?vue&type=script&lang=js"
import style0 from "./SchoolBanner.vue?vue&type=style&index=0&id=14b35df4&prod&scoped=true&lang=css"
import style1 from "./SchoolBanner.vue?vue&type=style&index=1&id=14b35df4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_729849d24245ac5da8661ad62b6d24d8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b35df4",
  null
  
)

export default component.exports